import {Injectable} from "@angular/core";
import {UserMarketingRulesRepository} from "@app/core/user-marketing-rules/domain/user-marketing-rules-repository";
import {MessageDisplayStrategy} from "@app/core/user-marketing-rules/application/message-display-strategy";
import {map} from "rxjs/operators";
import {Observable} from "rxjs";

/**
 * Use case to check if the Download App message should be displayed.
 */
@Injectable({
    providedIn: "root",
})
export class ShouldDisplayDownloadAppMessageUseCase {
    constructor(
        private userMarketingRulesRepository: UserMarketingRulesRepository,
        private messageDisplayStrategy: MessageDisplayStrategy,
    ) {}

    /**
     * Check if the Download App message should be displayed.
     * @returns true if the message should be displayed, false otherwise.
     */
    execute(): Observable<boolean> {
        return this.userMarketingRulesRepository.search().pipe(
            map((userMarketingRules) => {
                // The message only can be displayed when the strategy says so.
                if (!this.messageDisplayStrategy.canDisplayDownloadAppMessage()) {
                    return false;
                }
                // The message is displayed if the user marketing rules is not found, as it cannot be determined whether the user has seen it.
                if (userMarketingRules == null) {
                    return true;
                }
                // Evaluates whether the "Download App" message is allowed to be shown according to the user's marketing rules.
                return userMarketingRules.shouldDisplayDownloadAppMessage();
            }),
        );
    }
}